import { databases } from './appwrite';
import { ID, Models } from 'appwrite';
import { environment } from '../../../../environments/environment';

export enum COLLECTION {
  PROPERTIES = 'properties',
  WALLET = 'wallet',
  WALLET_TRANSACTIONS = 'walletTransactions',
  CART = 'cart',
  BOOKMARKS = 'bookmarks',
  PORTFOLIO = 'portfolio',
  MY_PROPERTIES = 'myProperties',
}

const collections = [
  {
    databaseId: environment.appwrite.databaseId,
    id: environment.appwrite.collectionIdProperties,
    name: COLLECTION.PROPERTIES,
  },
  {
    databaseId: environment.appwrite.databaseId,
    id: environment.appwrite.collectionIdWallet,
    name: COLLECTION.WALLET,
  },
  {
    databaseId: environment.appwrite.databaseId,
    id: environment.appwrite.collectionIdWalletTransactions,
    name: COLLECTION.WALLET_TRANSACTIONS,
  },
  {
    databaseId: environment.appwrite.databaseId,
    id: environment.appwrite.collectionIdCart,
    name: COLLECTION.CART,
  },
  {
    databaseId: environment.appwrite.databaseId,
    id: environment.appwrite.collectionIdBookmarks,
    name: COLLECTION.BOOKMARKS,
  },
  {
    databaseId: environment.appwrite.databaseId,
    id: environment.appwrite.collectionIdPortfolio,
    name: COLLECTION.PORTFOLIO,
  },
  {
    databaseId: environment.appwrite.databaseId,
    id: environment.appwrite.collectionIdMyProperties,
    name: COLLECTION.MY_PROPERTIES,
  },
];

const db: { [key: string]: any } = {};
collections.forEach((collection) => {
  db[collection.name] = {
    create: (
      payload: Omit<Models.Document, keyof Models.Document>,
      permissions: string[] | undefined,
      id = ID.unique()
    ) =>
      databases.createDocument(
        collection.databaseId,
        collection.id,
        id,
        payload,
        permissions
      ),
    update: (
      id: string,
      payload: Partial<Omit<Models.Document, keyof Models.Document>> | undefined
    ) =>
      databases.updateDocument(
        collection.databaseId,
        collection.id,
        id,
        payload
      ),
    get: (id: string) =>
      databases.getDocument(collection.databaseId, collection.id, id),
    delete: (id: string) =>
      databases.deleteDocument(collection.databaseId, collection.id, id),
    list: (queries: string[] | undefined) =>
      databases.listDocuments(collection.databaseId, collection.id, queries),
  };
});

export { db };
